import { JiraProject, JiraProjectCategory } from "resource-planner-model";
import { LoadStatus } from "../redux/LoadStatus";

export const FETCH_JIRA = "jira/fetch";
export const DO_FETCH_JIRA = "jira/do_fetch";
export const FAIL_JIRA = "jira/fail";
export const LOAD_JIRA = "jira/load";

export interface FetchJiraAction {
  type: typeof FETCH_JIRA;
  force?: boolean;
}

export interface DoFetchJiraAction {
  type: typeof DO_FETCH_JIRA;
}

export interface LoadJiraAction {
  type: typeof LOAD_JIRA;
  projects: JiraProject[];
  projectCategories: JiraProjectCategory[];
  loadedAt?: number;
}

export interface FailJiraAction {
  type: typeof FAIL_JIRA;
  error: unknown;
}

export interface JiraState {
  synching: boolean;
  status: LoadStatus;
  projects: JiraProject[];
  projectCategories: JiraProjectCategory[];
}

export type JiraAction =
  | FetchJiraAction
  | DoFetchJiraAction
  | FailJiraAction
  | LoadJiraAction;
